export const CATEGORY_OPTIONS = [
  { label: 'URBAN TXT', value: 'urban_txt' },
  { label: 'Program', value: 'program' },
  { label: 'Procedures', value: 'procedures' },
  { label: 'Guidelines', value: 'guidelines' },
];

export const CHUNK_STRATEGY_OPTIONS = [
  { label: 'By paragraph (default)', value: 'by_paragraph' },
  { label: 'By slide', value: 'by_slide' },
  { label: 'By row', value: 'by_row' },
  { label: 'By question', value: 'by_question' },
  { label: 'By section', value: 'by_section' },
];
